import React from 'react';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import { t } from 'ttag';
import { useMutation } from '@apollo/react-hooks';

import Form from '../../components/Form';
import AdminBaseLayout from '../../components/CabinetBaseLayout';
import { runTaskMutation } from './mutations';
import useNotifier from '../../components/Messages/hooks';

const BaseForm = ({ initial, onSubmit, errors }) => (
  <Form onSubmit={() => null} initial={initial} errors={errors}>
    {() => (
      <div>
        <Button
          style={{ margin: '20px 0 20px 0' }}
          margin='normal'
          type='button'
          fullWidth
          variant='contained'
          color='primary'
          onClick={() => onSubmit('sync_permissions')}
        >
          {t`Синхронизация доступов`}
        </Button>
        <br />
        <Button
          style={{ margin: '20px 0 20px 0' }}
          margin='normal'
          type='button'
          fullWidth
          variant='contained'
          color='primary'
          onClick={() => onSubmit('sync_trainers')}
        >
          {t`Синхронизация тренеров`}
        </Button>
        <br />
        <Button
          style={{ margin: '20px 0 20px 0' }}
          margin='normal'
          type='button'
          fullWidth
          variant='contained'
          color='primary'
          onClick={() => onSubmit('sync_athletes')}
        >
          {t`Синхронизация спортсменов`}
        </Button>
      </div>
    )}
  </Form>
);

const getInitialData = (row) => ({
  task: row.task || '',
});

export const RunTaskForm = () => {
  const pushMessage = useNotifier();
  const [runTask] = useMutation(runTaskMutation, {
    onCompleted: (d) => {
      const { runTask } = d;
      if (runTask.ok) {
        pushMessage({ text: 'Успішно запущено' });
      } else {
        pushMessage({ text: 'Щось пішло не так :(' });
      }
    },
  });

  const handleSubmit = (taskName) => {
    runTask({ variables: { task: taskName } });
  };

  return (
    <AdminBaseLayout>
      <Paper>
        <Box m={4}>
          <BaseForm
            initial={getInitialData({})}
            onSubmit={handleSubmit}
            errors={[]}
            edit={false}
            showPasswordField
          />
        </Box>
      </Paper>
    </AdminBaseLayout>
  );
};
